import apiHandler from "@/api/apps/apiHandler"
import apiUtils from "@/api/apiUtils"
import {$axios, $session} from "dot-framework";

const key = "/drive-app"
const version = "/v1"

export default {
    getDtmsGroup: async function (params) {
        const path = "/dtms/group/path"
        const data = apiUtils.removeNullValues(params)
        const url = apiUtils.makeUrl(key, version, path, data)
        const res = await apiHandler.$get(url)
        
        return apiUtils.getResponseData(res)
    },
    uploadImage: async function (form) {
        const path = "/doc/image"
        const url = apiUtils.makeUrl(key, version, path)
        const res = await apiHandler.$post(url, form)
        
        return apiUtils.getResponseData(res)
    },
    getDtmImageToDtms: async function (dtmNo, deviceKind) {
        const path = `/dtm/images/${dtmNo}/device/${deviceKind}/to-dtms`
        const url = apiUtils.makeUrl(key, version, path)
        const res = await apiHandler.$get(url)
        
        return apiUtils.getResponseData(res)
    },
    deleteCanvasDTMS: async function (dtmsFileNo, userNo) {
        const path = `/dtm/images/${dtmsFileNo}`
        const params = {
            "USER_NO": userNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)
        
        return apiHandler.$delete(url)
    },
    createDtmGroup: async function (params) {
        const path = "/dtm/groups"
        const url = apiUtils.makeUrl(key, version, path)
        const res = await apiHandler.$post(url, params, null, true)
        
        return apiUtils.getResponseData(res)
    },
    createDtmsImages: async function (formData) {
        const path = "/dtms/images"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, true)
    },
    changeDtmsStatus: async function (type, fileKey, params) {
        const path = `/dtm/${type}/${fileKey}/status`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$patch(url, params, true)
    },
    openDtmsImage: async function (fileKey, params) {
        const path = `/dtms/images/${fileKey}/open`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, true)
    },
    closeDtmsImage: async function (fileKey) {
        const path = `/dtms/images/${fileKey}/open`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$delete(url, null, true)
    },
    renameFolder: async function (fileKey, params) {
        const path = `/dtm/groups/${fileKey}`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$put(url, params, true)
    },
    renameFile: async function (fileKey, params) {
        const path = `/dtms/images/${fileKey}`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$put(url, params, true)
    },
    copyFolder: async function (fileKey, params) {
        const path = `/dtms/groups/${fileKey}/copy`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, true)
    },
    copyFile: async function (fileKey, params) {
        const path = `/dtms/images/${fileKey}/copy`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, true)
    },
    getDtmsGroupList: async function (params) {
        const path = "/dtms/groups"
        const query = apiUtils.removeNullValues(params)
        const url = apiUtils.makeUrl(key, version, path, query)
        
        return await apiHandler.$get(url, null, true)
    },
    saveAsTextbook: async function (formData) {
        const path = `/doc/html/from-string`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData)
    },
    updateHtmlDocs: async function (params) {
        const path = `/doc/html`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$put(url, params)
    },
    uploadPdfToText: async function (formData) {
        const path = "/image/pdfToText"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, true)
    },
    getBrl: async function (dtmNo) {
        const path = "/doc/brl"
        const params = {
            "DTM_NO": dtmNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)
        
        return apiHandler.$get(url, null, false)
    },
    uploadDTMA: async function (formData) {
        const path = "/dtma/images/upload-to-json"
        const url = apiUtils.makeUrl(key, version, path)

        return apiHandler.$post(url, formData)
    },
    uploadDtmaToCloud: async function (formData) {
        const path = "/dtma/images"
        const url = apiUtils.makeUrl(key, version, path)

        return apiHandler.$post(url, formData, true)
    },
    // 대용량 .dtma 업로드용 presigned PUT URL 발급(브라우저가 S3로 직접 업로드)
    presignDtmaUpload: async function (fileName) {
        const path = "/dtma/images/presign"
        const url = apiUtils.makeUrl(key, version, path, { FILE_NAME: fileName })

        return apiHandler.$post(url)
    },
    // S3에 올라간 .dtma 처리 접수(비동기). 응답으로 JOB_ID 를 받는다.
    uploadDtmaFromS3: async function (payload) {
        const path = "/dtma/images/from-s3"
        const url = apiUtils.makeUrl(key, version, path, payload)

        return apiHandler.$post(url)
    },
    // 비동기 처리 상태 조회(폴링)
    getDtmaUploadStatus: async function (jobId) {
        const path = "/dtma/images/upload-status"
        const url = apiUtils.makeUrl(key, version, path, { JOB_ID: jobId })

        return apiHandler.$get(url)
    },
    // 대용량 .dtma 다운로드 준비 접수(비동기). 응답으로 JOB_ID 를 받는다.
    prepareDtmaDownload: async function (dtmNo, fileName) {
        const path = "/dtma/images/download-prepare"
        const url = apiUtils.makeUrl(key, version, path, { DTM_NO: dtmNo, FILE_NAME: fileName })

        return apiHandler.$post(url)
    },
    // 다운로드 준비 상태 조회(폴링). 완료 시 DOWNLOAD_URL(presigned S3 GET) 수신
    getDtmaDownloadStatus: async function (jobId) {
        const path = "/dtma/images/download-status"
        const url = apiUtils.makeUrl(key, version, path, { JOB_ID: jobId })

        return apiHandler.$get(url)
    },
    uploadDTMS: async function (formData) {
        const path = "/dtms/images/upload-to-json"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, null, true)
    },
    // 오디오가 있는 문서도 아래 getFileDTMSImages(/dtm/images/...) 로 연다.
    // /dtma/images/{no}/device/{kind}/to-dtms 는 audioPath 와 audio.fileName 을 빈 값으로
    // 지워서 돌려주므로(2026-08 dev 서버 실측), 이름만 보고 그쪽으로 바꾸면 오디오가 사라진다.
    // 그래서 쓰지 않는 getFileDTMAImages 는 남겨 두지 않는다.
    getFileDTMSImages: async function (fileno, canvasType) {
        const path = "/dtm/images/" + fileno + "/device/" + canvasType + "/to-dtms"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$get(url, null, true)
    },
    // showLoading: 전체 로딩 창을 띄울지. 이미 떠 있는 창 뒤에서 맞추는 것이면 끈다(발표 모드, DCW-1979).
    getAudioSync: async function (dtmNo, {showLoading = true} = {}) {
        const path = "/dtma/audio/sync"
        const params = {
            "DTM_NO": dtmNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)

        //return apiHandler.$get(url)
        return apiHandler.$get(url, null, showLoading);
    },
    getDTMSImage: async function (params) {
        const path = "/dtm/images"
        const query = apiUtils.removeNullValues(params)
        const url = apiUtils.makeUrl(key, version, path, query)
        
        return apiHandler.$get(url, null, true)
    },
    getDaisyContent: async function (dtmNo) {
        const path = "/doc/daisy-contents"
        const params = {
            "DTM_NO": dtmNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)

        return apiHandler.$get(url)
    },
    increaseDtmViewCount: async function (dtmNo, userNo) {
        const path = "/dtms/view-count"
        const url = apiUtils.makeUrl(key, "/v2", path)
        const payload = {
            dtmNo: dtmNo,
            userNo: userNo,
        }
        const params = apiUtils.paramFormatter(payload)

        return apiHandler.$post_noloading(url, params)
    },
    addDtms: async function (params) {
        const path = "/dtm/images/from-dtms"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, null, true)
    },
    // 캔버스 저장시 loading 모달이 뜨기 때문에 loading 없는 함수 추가
    addDtms_noloading: async function (params) {
        const path = "/dtm/images/from-dtms"
        // const path = "/dtm/images/from-dtmsttt" // 오류 테스트
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post_noloading(url, params, null, true)
    },
    updateDtms: async function (fileNo, params) {
        const path = "/dtm/images/" + fileNo + "/from-dtms"
        const url = apiUtils.makeUrl(key, version, path)

        return apiHandler.$post(url, params, null, true);
    },
    // 캔버스 저장시 loading 모달이 뜨기 때문에 loading 없는 함수 추가
    updateDtms_noloading: async function (fileNo, params) {
        const path = "/dtm/images/" + fileNo + "/from-dtms"
        const url = apiUtils.makeUrl(key, version, path)

        return apiHandler.$post_noloading(url, params, null, true)
    },
    // 캔버스 저장시 사용. 캔버스에서 로딩 이미지 띄우기 때문에 수정
    saveAudio: async function (formData) {
        const path = "/dtma/audio"
        const url = apiUtils.makeUrl(key, version, path)
        
        // return apiHandler.$post(url, formData, true)
        // return apiHandler.$post(url, formData, null, true);
        return apiHandler.$post_noloading(url, formData, null);
    },
    // 오디오 삭제는 쿼리로 보낸다. multipart 본문으로 보내면 서버가 400 을 낸다.
    // (FormData 를 넘기던 예전 방식은 $delete 의 config 자리로 들어가 본문이 아예 실리지도 않았다.)
    removeAudio: async function (dtmNo, fileName) {
        const path = "/dtma/audio"
        const params = {
            "DTM_NO": dtmNo,
            "FILE_NAME": fileName
        }
        const url = apiUtils.makeUrl(key, version, path, params)

        // 저장 도중에 불린다. 전역 로딩 모달을 띄우면 저장 토스트와 겹치므로 예전처럼 띄우지 않는다.
        return apiHandler.$delete(url)
    },
    getRemainingDrive: async function (params) {
        const path = "/doc/remaining"
        const url = apiUtils.makeUrl(key, version, path, params)
        const res = await apiHandler.$get(url)
        
        return apiUtils.getResponseData(res)
    }
}